import React, { useState, useEffect } from "react";
import axios from "axios";
import WalletTicketsItem from "./WalletTicketsItem";
import WalletTicketsSkeleton from "./WalletTicketsSkeleton";
import WalletTicketsRow from "./WalletTicketsRow";
import Ticket from "./Ticket";
import TicketDashedLine from "./TicketDashedLine";
import TicketMain from "./TicketMain";
import TicketMainBottomRow from "./TicketMainBottomRow";
import TicketMainMiddleRow from "./TicketMainMiddleRow";
import TicketMainTopRow from "./TicketMainTopRow";
import TicketStub from "./TicketStub";
import TicketText from "./TicketText";
import { EmptyScreen } from "fiver-react-ui-components";
const skeletons = [1, 2, 3, 4];

const Wrapper = ({
  onError
}) => {
  const [transactions, setTransactions] = useState();
  const currencySymbol = process.env.REACT_APP_CURRENCY_SYMBOL || "£";
  useEffect(() => {
    (async function () {
      try {
        const transactionsRes = await axios.get(`/wallet/transactions?per_page=1000`); // setTimeout(() => {

        setTransactions(transactionsRes?.data?.data?.filter(item => item.type == "TICKET")); // }, 1000);
      } catch ({
        response
      }) {
        onError(response);
      }
    })();
  }, []);
  return transactions?.length > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, transactions.map(item => {
    const month = item?.document?.game_data.date.draw.date_time.month.name.short;
    const day = item?.document?.game_data.date.draw.date_time.day.name.number;
    const year = item?.document?.game_data.date.draw.date_time.year;
    const ticketText = (item?.document?.game_data?.descriptions?.short || item?.document?.game_data?.name).substring(0, 6);
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(WalletTicketsRow, {
      key: item?.id
    }, /*#__PURE__*/React.createElement(Ticket, null, /*#__PURE__*/React.createElement(TicketMain, null, /*#__PURE__*/React.createElement(TicketMainTopRow, {
      prizeImageUrl: item?.document?.game_data?.image?.url
    }, /*#__PURE__*/React.createElement(TicketText, {
      size: "lg",
      isSuccess: true,
      isBold: true
    }, ticketText)), /*#__PURE__*/React.createElement(TicketMainMiddleRow, null, /*#__PURE__*/React.createElement("div", {
      style: {
        marginRight: "1rem"
      }
    }, /*#__PURE__*/React.createElement(TicketText, {
      size: "sm",
      isUppercase: true,
      marginBottom: "0.25rem"
    }, "Ticket No."), /*#__PURE__*/React.createElement(TicketText, {
      size: "md",
      isUppercase: true,
      marginBottom: "0.25rem"
    }, item?.reference)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TicketText, {
      size: "sm",
      isUppercase: true,
      marginBottom: "0.25rem"
    }, "Payment"), /*#__PURE__*/React.createElement(TicketText, {
      size: "md",
      isUppercase: true,
      marginBottom: "0.25rem"
    }, currencySymbol, item?.document?.game_data?.ticket_price.pounds))), /*#__PURE__*/React.createElement(TicketMainBottomRow, null, /*#__PURE__*/React.createElement(TicketText, {
      size: "sm",
      isLabel: true
    }, "Live draw ", month, " ", day, ", ", year))), /*#__PURE__*/React.createElement(TicketDashedLine, null), /*#__PURE__*/React.createElement(TicketStub, {
      isClaimed: false
    }))));
  })) : transactions?.length === 0 ? /*#__PURE__*/React.createElement(EmptyScreen, {
    emptyIcon: "confirmation_number",
    emptyTitle: "No tickets yet",
    emptySubtitle: "Tickets can be purchased soon!"
  }) : skeletons.map(s => /*#__PURE__*/React.createElement(WalletTicketsSkeleton, {
    key: s
  }));
};

export default Wrapper;